const ROOT = "/society-violation-management";

const societyViolationManagementPaths = {
  root: ROOT,
  //   AddViolation: `${ROOT}/add-violation`,
};

export default societyViolationManagementPaths;
